<template>
  <div id="gwstatus">
    <v-container fluid>
      <v-row>
        <v-col
          v-for="item in sensorData"
          :key="item.text"
          cols="12"
          md="2"
          sm="12"
          style="min-width: 250px"
        >
          <v-card
            class="vcard"
            :class="item.dclass"
          >
            <v-card-text>
              <div>
                <v-row>
                  <v-col cols="12">
                    <div class="inner-text">
                      <span style=" color : #00205b;font-size:16px;font-weight:bold ;max-width: 100px">{{ item.gw_desc }}</span>
                      <br>
                      <span>{{ item.ip_adrs }}</span>
                      <br>
                      <div style="text-align:right;font-size:44px;font-weight:bold;text-align:right;color:#fff">
                        {{ item.did }}
                      </div>
                      <div v-if="item.gray">
                        <span style=" font-weight:bold">離線中</span>
                      </div>
                      <div v-else-if="item.green">
                        <span style="  font-weight:bold">運行中</span>
                      </div>
                      <div v-else-if="item.yellow">
                        其他
                      </div>
                      <div v-else-if="item.red">
                        緊急停止
                      </div>
                      <span>{{ item.dat }}</span>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div> 
</template>

<script>
import Cookies from "js-cookie";

export default {
  data: () => ({
    time: null,
    sensorData: [],
  }),
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  created: function () {
    Cookies.set("url", "/ReportStatus");
    this.init();
    this.time = setInterval(() => {
      this.init();
    }, 60 * 1000);
  },
  unmounted() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    init() {
      let that = this;
      let nform = {
        cust_id: this.loginInfo.cust_id,
        uid: this.loginInfo.uid,
        
      };
      this.$store
        .dispatch("exec_gw_status", nform)
        .then((res) => {
          // console.log(res);
          this.sensorData = [];
          this.sensorData = res;
          let array = res;
          //  this.sensorData= this.sensorData.concat( array)
          // console.log( this.sensorData)
          this.sensorData = this.sensorData.map(function (item) {
            item = item;
            let gray = false;
            let green = false;
            let yellow = false;
            let red = false;
            let dclass = "gray";

            if (item.on_off == "1") {
              green = true;
              dclass = "green";
            } else if (item.on_off == "2") {
              yellow = true;
              dclass = "yellow";
            } else if (item.on_off == "3") {
              red = true;
              dclass = "red";
            } else if (item.on_off == "0") {
              gray = true;
            }
            item.green = green;
            item.gray = gray;
            item.yellow = yellow;
            item.red = red;
            item.dclass = dclass;
            return item;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.vcard .v-card__text {
  padding: 8px !important;
}

.red {
  background: red !important;
}

.gray {
  background: gray !important;
}

.yellow {
  background: yellow !important;
}

.green {
  background: #237f52 !important;
}

.chart {
  width: 100% !important;
  margin-right: 10px;
  float: left;
  height: 100% !important;
  max-height: 200px !important;
}

.inner-text {
  width: 100%;
  height: 100%;
}

.inner-text--3 {
  display: flex;
  justify-content: center;
  margin-top: 85px;
  font-size: 20px;
  color: #de3a21;
  font-weight: 700;
}
</style>

<style scoped>
#gwstatus{
height: 100%;
background-color: #263238;
}
</style>